import { observer } from 'mobx-react-lite'
import { Box, Switch, Typography } from 'shared/ui'
import { KnowledgeBasePath } from 'entities/ExportRouters'
import { AgentKnowledgeBase } from 'pages/chatbot/ui/AgentKnowledgeBase/AgentKnowledgeBase'
import { useUnifiedAgentContext } from 'pages/chatbot/ui/UnifiedAgent/context/unifiedAgentContext'
import styles from './styles.module.scss'

export const KnowledgeBase = observer(() => {
  const { knowledgeBaseSectionStore } = useUnifiedAgentContext()
  const {
    agentKnowledgeBaseStore,
    useKnowledgeBase,
    setUseKnowledgeBase,
    documents,
    setDocuments,
  } = knowledgeBaseSectionStore

  return (
    <>
      <Box display={'flex'}>
        <Box display={'flex'} flexDirection={'column'} flexGrow={'1'}>
          <Typography variant={'body-lg-medium'} ariaLabel={'KnowledgeBase'}>
            Knowledge Base
          </Typography>
          <Typography
            variant={'body-md-regular'}
            ariaLabel={'KnowledgeBaseDesc'}
            color={'var(--content-primary-secondary)'}
            marginTop={4}
            marginBottom={useKnowledgeBase ? 24 : 0}
          >
            Improve response accuracy.{' '}
            <a
              href={`/${KnowledgeBasePath.root}`}
              target={'_blank'}
              rel='noreferrer'
              className={styles.learnMoreLink}
            >
              Manage knowledge base
            </a>
          </Typography>
        </Box>
        <Box paddingTop={'4px'}>
          <Switch value={useKnowledgeBase} onChange={setUseKnowledgeBase} size='middle' />
        </Box>
      </Box>
      {useKnowledgeBase && (
        <div>
          <AgentKnowledgeBase
            isOnlyButton
            knowledgeBaseUsage={useKnowledgeBase}
            agentKnowledgeBaseStore={agentKnowledgeBaseStore}
            setKnowledgeBaseUsage={setUseKnowledgeBase}
            setKnowledgeBaseDocuments={setDocuments}
            knowledgeBaseDocuments={documents}
            isShowToggle={false}
          />
        </div>
      )}
    </>
  )
})
